import Vue from "vue";

export default {
    changeUntersuchungByIndex(state, untersuchungAndIndex) {
        Vue.set(state.untersuchungen, untersuchungAndIndex.index, untersuchungAndIndex.untersuchung)
    },
    deleteTU(state, index) {
        state.untersuchungen.splice(index, 1)
    },
    changeDateOfTechnischeUntersuchung(state, dateAndIndex) {
        state.untersuchungen[dateAndIndex.index].date = dateAndIndex.date
    },
    pushUntersuchungToUntersuchungenList(state, untersuchung) {
        state.untersuchungen.push(untersuchung)
    }
}